/**
 * Request header the browser sets on POST /api/login to say which flow
 * triggered it. Purely a log tag (spoofable, never trusted for decisions) —
 * it lets the BotID monitor phase tell form logins apart from the silent
 * post-signup auto-login, which has no UI to surface a block.
 */
export const LOGIN_SOURCE_HEADER = 'x-viv-login-source';

export const LOGIN_SOURCES = ['login_form', 'signup_auto_login'] as const;

export type LoginSource = (typeof LOGIN_SOURCES)[number];

/** Allow-lists the header value so arbitrary client strings never reach logs. */
export function parseLoginSource(raw: string | null): LoginSource | 'unknown' {
  return LOGIN_SOURCES.includes(raw as LoginSource)
    ? (raw as LoginSource)
    : 'unknown';
}
